// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import * as sdk from '@canton-network/dapp-sdk';
import { useMutation } from '@tanstack/react-query';
import hash from 'object-hash';
import { Party, Template } from '@daml/types';
import { LedgerCreateArgs } from '../../../utils/LedgerApiClientV2';

export const useDappSdkCreate = <T extends object, K, I extends string>(
  template: Template<T, K, I>,
) => {
  return useMutation({
    mutationKey: ['dappSdkCreate'],
    mutationFn: async (args: LedgerCreateArgs<T>) => {
      let actAs: Party[] | undefined;
      let readAs: Party[] | undefined;

      if (args.submitter) {
        actAs = [args.submitter];
      } else {
        actAs = args.actAs;
        readAs = args.readAs;
      }
      const commandId = hash({
        templateId: template.templateId,
        argument: args.argument,
        actAs,
        readAs,
      });
      return sdk.prepareExecute({
        commands: [
          {
            CreateCommand: {
              templateId: template.templateId,
              createArguments: template.encode(args.argument),
            },
          },
        ],
        commandId,
      });
    },
  });
};
